import React from "react";
import { Box, Typography, Card, CardContent, useTheme, Divider } from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
} from "@mui/icons-material";

const ZohoSyncCard = ({ syncStatus }) => {
  const theme = useTheme();

  const rawStatus = syncStatus?.status || "";
  const normalized = rawStatus.toLowerCase();
  const isSuccess =
    normalized.includes("success") || normalized === "synced" || normalized === "completed";

  return (
    <Card
      elevation={2}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow:  
          theme.palette.mode === "dark"
            ? "0px 1px 3px rgba(0, 0, 0, 0.3)"
            : "0px 1px 3px rgba(0, 0, 0, 0.1)",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, mb: 2.5, color: theme.palette.text.primary }}
        >
          Zoho Sync Status
        </Typography>

        <Box sx={{ display: "flex", alignItems: "flex-start", minWidth: 0 }}>
          {isSuccess ? (
            <CheckCircleIcon
              sx={{
                fontSize: 32,
                color: "#10b981",
                mr: 1,
               
              }}
            />
          ) : (
            <ErrorIcon
              sx={{
                fontSize: 30,
                color: "#ef4444",
                mr: 1,
                
              }}
            />
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                mb: 1,
                color: theme.palette.text.primary,
                overflowWrap: "anywhere",
              }}
            >
              {syncStatus.status}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{display: "inline", overflowWrap: "anywhere" }}
            >
              <Box component="span" sx={{ fontWeight: 600,mb: 1 }}>
                Zoho Synced At:
              </Box>{" "}
              {syncStatus.timestamp}
            </Typography>
            {/* <Divider sx={{ mt: 1 }} />
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              mt={1}
              sx={{ overflowWrap: "anywhere" }}
            >
              {syncStatus.message}
              {syncStatus.status === "Success" ? syncStatus.message : syncStatus.status}
            </Typography> */}
          </Box>
        </Box>  
      </CardContent>
    </Card>
  );
};

export default ZohoSyncCard;
